<template>
  <div>
    <div class="row pb-5" :class="team.title == 'Operações' ? 'operacoes' : ''">
      <div class="col-12 col-lg-10 mx-auto mt-n4">
        <b-card no-body class="border-0 bg-transparent">
          <b-tabs
            card
            no-nav-style
            nav-wrapper-class="shadow-sm border-0 card-nav-tabs font-weight-bold"
            v-model="tabIndex"
          >
            <b-tab
              title="SOBRE"
              class="row"
              v-if="team.content || team.gallery"
            >
              <div class="bg-white shadow-sm p-4 p-md-5">
                <div
                  class="row"
                  v-if="team.gallery && team.gallery.length == 1"
                >
                  <div class="col-12 col-md-5 mb-3">
                    <Gallery
                      :items="team.gallery"
                      :custom_class="'h-scroll-down-md'"
                      itemsW="100%"
                      itemsH="500px"
                      itemsMargin="0 .4%"
                    />
                  </div>
                  <div class="col-12 col-md-7" v-html="team.content"></div>
                </div>

                <div class="row" v-else>
                  <div class="col-12 mb-3" v-html="team.content"></div>
                  <div class="col-12">
                    <Gallery
                      :items="team.gallery"
                      :custom_class="'h-scroll-down-md'"
                      itemsW="33%"
                      itemsH="200px"
                      itemsMargin="0 .4%"
                    />
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="OPORTUNIDADES" class="row" @click="scroll">
              <Jobs :search="true" />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Jobs from "@/components/jobs/Jobs.vue";
import Gallery from "@/components/media/Gallery.vue";

export default {
  name: "TeamPage",

  data() {
    return {
      tabIndex: 0,
    };
  },

  head() {
    return this.$head({
      title: `${this.team.title} | `,
    });
  },

  props: {
    team: Object,
  },

  components: {
    Jobs,
    Gallery,
  },

  methods: {
    scroll() {
      window.scroll(0, 1);
    },
  },

  mounted() {
    if (this.$route.name == "teamsJobsOpen")
      setTimeout(() => (this.tabIndex = 1), 100);
  },
};
</script>

<style lang="scss" >
.operacoes {
  .image-box {
    background-position: right;
  }
}

.teams {
  .card-nav-tabs {
    width: calc(100% + (100vw - 100%) / 2);
    background-color: #fff;
    position: sticky;
    top: 55px;
    z-index: 20;
    border-bottom-left-radius: 30px;

    ul {
      justify-content: start;
      padding-left: 20px;
      outline: none;

      li {
        a {
          color: color("gray");
          border-bottom: 2px solid theme-color("white");
          padding-left: 1rem;
          padding-right: 1rem;
          &.active {
            border-bottom-color: theme-color("blue-ml");
            color: theme-color("blue-ml");
          }
        }
      }
    }
  }

  dd {
    p {
      margin-bottom: 9px;
    }
  }
}
</style>